/**
 * Dashboard Page
 *
 * Minimal authenticated dashboard showing user info and sign-out.
 * This is intentionally minimal — just a working authenticated surface.
 */

import { createFileRoute } from '@tanstack/react-router'
import { useAuth } from '@lib/auth'

export const Route = createFileRoute('/_authenticated/dashboard/')({
  component: Dashboard,
})

function Dashboard() {
  const { user, logout } = useAuth()

  return (
    <div className="h-screen flex items-center justify-center bg-black">
      <div className="text-center">
        <h1 className="font-mono text-white text-2xl font-bold mb-4">
          Dashboard
        </h1>
        <p className="font-mono text-neutral-400 text-sm mb-2">
          {user?.name ?? user?.email ?? 'Authenticated User'}
        </p>
        {user?.email && user.name && (
          <p className="font-mono text-neutral-500 text-xs mb-8">
            {user.email}
          </p>
        )}
        <button
          onClick={() => logout()}
          className="font-mono px-6 py-3 bg-neutral-800 text-white font-semibold hover:bg-neutral-700 transition-colors"
        >
          Sign Out
        </button>
      </div>
    </div>
  )
}
